export default __webpack_public_path__ + "static/media/playing_conditions.8106403a.pdf";